import request from '@/utils/request'

// 批次列表
export const goodsBatch_getList=(data)=>{
  return request({
    url: '/erp-pos/base-goods-batch/index',
    method: 'get',
    data
  })
}

// 批次变更统计
export const goodsBatch_data=(data)=>{
  return request({
    url: '/erp/base-goods-batch/sale-statistics',
    method: 'get',
    data
  })
}

// 新增批次
export const batch_create=(data)=>{
  return request({
    url: '/erp/base-goods-batch/create',
    method: 'post',
    data
  })
}

// 批次售罄
export const batch_sellout=(data)=>{
  return request({
    url: '/erp/base-goods-batch/sell-out',
    method: 'post',
    data
  })
}

// 获取批次号
export const batch_getNum = (data) => {
  return request({
      url: '/erp/base-goods-batch/get-batch-num',
      method: 'get',
      data
  })
}

// 商品接口 --按批次
export const goods_getList=(data)=>{
  return request({
    url: '/erp-pos/base-goods/index',
    method: 'get',
    data
  })
}

// 商品详情
export const goods_detail=(data)=>{
  return request({
    url: '/erp-pos/base-goods/detail',
    method: 'get',
    data
  })
}

// 商品新增 http://doc.hzhhkeji.com/index.php?s=/49&page_id=1921
export const goods_create=(data)=>{
  return request({
    url: '/erp/base-goods/edit-goods',
    method: 'post',
    data
  })
}

// 获取商品的分类
export const goodsCate_getList=(data)=>{
  return request({
    url: '/erp/commodity-library/cate-list',
    method: 'get',
    data
  })
}

// 商品编辑
export const goods_update=(data)=>{
  return request({
    url: '/erp-pos/base-goods/edit',
    method: 'post',
    data
  })
}

// 商品售罄
export const goodsSoldOut_handle=(data)=>{
  return request({
    url: '/erp/base-goods/delete',
    method: 'post',
    data
  })
}

// 商品开售
export const goodsChangeStatus_handle=(data)=>{
  return request({
    url: '/erp/base-goods/edit-status',
    method: 'post',
    data
  })
}

// 商品补货
export const goodsReplenish_handle=(data)=>{
  return request({
    url: '/erp/stock-take/replenish',
    method: 'post',
    data
  })
}

// 商品盘点
export const goodsInventory_handle=(data)=>{
  return request({
    url: '/erp/stock-take/inventory',
    method: 'post',
    data
  })
}
// 商品报损
export const goodsBrake_handle=(data)=>{
  return request({
    url: '/erp/base-damaged/create',
    method: 'post',
    data
  })
}


// 商品删除
export const goods_delete=(data)=>{
  return request({
    url: '/erp/base-goods/delete-goods',
    method: 'post',
    data
  })
}







// 批次费用列表接口
export const batchSurcharge_getList=(data)=>{
  return request({
    url: '/erp/base-goods-batch/surcharge-batch-list',
    method: 'get',
    data
  })
}
// 批次费用列表接口编辑
export const batchSurcharge_update=(data)=>{
  return request({
    url: '/erp/base-goods-batch/edit-surcharge-batch',
    method: 'post',
    data
  })
}
// 批次费用列表接口删除
export const batchSurcharge_delete=(data)=>{
  return request({
    url: '/erp/base-goods-batch/del-surcharge-batch',
    method: 'post',
    data
  })
}



/**
 * 其他
 */
// 销售附加费 列表
export const saleFee_getList=(data)=>{
  return request({
    url: '/erp/base-surcharge/list',
    method: 'post',
    data
  })
}
// 销售附加费 添加修改
export const saleFee_update=(data)=>{
  return request({
    url: '/erp/base-surcharge/create',
    method: 'post',
    data
  })
}
// 销售附加费 删除
export const saleFee_delete=(data)=>{
  return request({
    url: '/erp/base-surcharge/delete',
    method: 'post',
    data
  })
}

// 销售附加费统计
export const saleFee_data=(data)=>{
  return request({
    url: '/erp/base-surcharge/surcharge-statistics',
    method: 'get',
    data
  })
}



// 成本费用列表接口
export const costFee_getList=(data)=>{
  return request({
    url: '/erp/surcharge/index',
    method: 'get',
    data
  })
}
// 成本费新增编辑
export const costFee_update=(data)=>{
  return request({
    url: '/erp/surcharge/edit',
    method: 'post',
    data
  })
}
// 成本费删除
export const costFee_delete=(data)=>{
  return request({
    url: '/erp/surcharge/delete',
    method: 'post',
    data
  })
}


// 成本费统计
export const costFee_data=(data)=>{
  return request({
    url: '/erp/base-goods-batch/surcharge-batch-statistics',
    method: 'get',
    data
  })
}
